@if (featureSection().items.length) {
  <app-menu-section
    [section]="featureSection()"
    [iconOnly]="iconOnly()"
    (itemSelect)="onOtherSectionSelect($event)"
  />
}

<!-- Temporarily hidden: padlocked courses are no longer browsable while
     unsubscribed — see CoursesComponent, which now redirects to the free
     taster viewer (or onboarding) instead. Restore by dropping the
     `false &&` below. -->
@if (false && courseSection().items.length) {
  <app-menu-section
    [section]="courseSection()"
    [iconOnly]="iconOnly()"
    [selectedId]="selectedCourseId"
    (itemSelect)="onCourseSelect($event)"
  />
}

@if (campaignSection().items.length) {
  <app-menu-section
    [section]="campaignSection()"
    [iconOnly]="iconOnly()"
    (itemSelect)="onOtherSectionSelect($event)"
  />
}

@if (packagesSection().items.length) {
  <app-menu-section
    [section]="packagesSection()"
    [iconOnly]="iconOnly()"
    (itemSelect)="onOtherSectionSelect($event)"
  />
}
